import React,{createRef } from "react";
import { LENDERS } from "../../consts/tables";
import LenderInfo from "./LenderInfo";
import LenderProperty from "./LenderProperty";
import NotesInfo from "./NotesInfo";
// import CRUD from "../CRUD/CRUD";
import { browserHistory } from "react-router";
import { getData, manageData } from "../../requests/CRUD";
import { ApolloConsumer } from "@apollo/client";
import { GET_LENDERS_BY_ID } from "../Graphql/Queries/LendersQuery";
import CRUDOLD from "../CRUD/CRUDOLD";
import { CREATE_UPDATE_LENDERS } from "../Graphql/Mutations/LendersMutation";
import { CREATE_OR_UPDATE_CONTACTS_LENDERS } from "../Graphql/ContactsMutations/allContactsMutation";
import { GET_CONTACT_LENDERS_LIST_QUERY, GET_LENDER_BY_CONTACTID } from "../Graphql/ContactsQueries/contactsQuery";
import { fetchData, mutateData } from "../Service/graphQlService";
import LenderCompanyInfo from "./LenderCompanyInfo";
import NotesReusable from "../NotesReusable";
import { sanitizeNotesForInput } from "../../utils";
import { UserContext } from "../Root/Root"; 

export default class CRUDLender extends React.Component {
  static get contextType() {
    return UserContext;
    }
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            original: null,
            isBusy: null,
            error: null,
            success: null,
            errorTabs: [],
            currentTab: 0,
            viewMode: this.props.edit || false,
            propertiesData: [],
            searchCrudFilter : false,
            filterData: [],
            currentIndex: 0,
            loggedInUserData: {},
            fromListUrl: props.location.state && props.location.state.fromListUrl || localStorage.getItem('fromListUrl') || null,
            isExists: false,
            typeDuplicate:null
        };

        this.client = null;
        this.notesRef = createRef();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.saveData = this.saveData.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.setPropertiesData = this.setPropertiesData.bind(this);
        this.updateURL = this.updateURL.bind(this);
        this.updateURL = this.updateURL.bind(this);
        this.handleNotesChange = this.handleNotesChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params.id !== nextProps.params.id) {
            this.fetch(nextProps.params.id);
        }
    }

    componentDidMount() {
      const userData = this.context.userData;
      this.setState({loggedInUserData: userData});
        if (this.state.fromListUrl) {
            localStorage.setItem('fromListUrl', this.state.fromListUrl);
            this.setState({ fromListUrl: this.state.fromListUrl });
          }
        //#region Below code executes when we click the Last name in MergeDuplicate screen
        const tabParam = this.props.location.query && this.props.location.query.tab;
        if (tabParam && !isNaN(tabParam)) {
            this.setState({ currentTab: parseInt(tabParam.trim(), 10) });
        }
        else{
            this.setState({ currentTab: 0 });
        }
        const queryParams = new URLSearchParams(this.props.location.search);
        queryParams.delete("tab");
        //#endregion
        const hasQuery = queryParams.toString().length > 0;
        if(!hasQuery){
          this.fetch(this.props.params.id);
        }
        if(hasQuery && !tabParam){
          this.setState({ searchCrudFilter: true });
          this.handleQueryChange();
        }
    }



    parseFilterOptions(query){
        const filterObject = {};
        if(query){
            for(const key in query){
                if(key !== 'order' && key !== 'page'){
                    filterObject[key]= query[key]
                }
            }
        }
        return [filterObject]
    }

    componentDidUpdate(prevProps) {
    
        const hasQuery = new URLSearchParams(this.props.location.search).toString().length > 0;
        const prevHasQuery = new URLSearchParams(prevProps.location.search).toString().length > 0;
        if (hasQuery && prevProps.location.search !== this.props.location.search) {
          this.handleQueryChange();
          this.setState({ searchCrudFilter: true });
        }
        // Check if the query has changed
        // if (prevProps.location.search !== this.props.location.search) {
        //   this.handleQueryChange();
        // }
        if(!hasQuery && prevHasQuery){
          this.fetch(this.props.params.id);
          this.setState({ searchCrudFilter: false });
        }
      }

handleNotesChange(updatedNotes, editId) {
  const cleanedNotes = updatedNotes
    .filter((note) => note.text && note.text.trim() !== "")
    .filter((note) => {
      // Case 1: new note (no arcimedes_row_id)
      if (!note.arcimedes_row_id) return true;

      // Case 2: edited note (arcimedes_row_id matches editId)
      if (editId && note.arcimedes_row_id === editId) return true;

      // Case 3: deleted note
      if (note.deleted === 1) return true;

      // Skip everything else
      return false;
    })
    .map(
      ({
        __typename,
        arcimedes_created,
        arcimedes_modified,
        arcimedes_created_by,
        arcimedes_modified_by,
        temp_id,
         date,
        ...rest
      }) => rest
    );

  this.setState((prev) => ({
    data: {
      ...prev.data,
      notes: cleanedNotes,
    },
  }));
}
    
      handleQueryChange() {
        const query = this.props.location.query;
        const { tab, ...restQuery } = query;
        const filterOptions = this.parseFilterOptions(restQuery); 
      
        var isNoFilter = Object.keys(filterOptions).length === 0; 
      
        if (isNoFilter) {
          this.fetch(this.props.params.id);
        }
        else{
          this.fetchWithFilter(filterOptions)
        }
      }
    
    fetchWithFilter(filterOptions) {
      this.setState({
        data: null,
        error: null,
        success: null,
      });
    
      fetchData(GET_CONTACT_LENDERS_LIST_QUERY, { type:"Lender",filters:filterOptions})
            .then(res => {
              const filterData = res.data.getContacts.data|| [];
              if(filterData.length > 0){

                const firstResult = filterData[0];
                const loggedInUserEmail = String(this.state.loggedInUserData.email);
                firstResult['hsc_hot_list'] = firstResult.hsc_id && firstResult.hsc_id.includes(loggedInUserEmail) ? '1' : '0';

                this.setState({
                  // items: res.data.getCompanies.data,
                  // totalCount: res.data.getCompanies.totalCount,
                  // error: null,
                  // isBusy: null,
                  filterData,
                  currentIndex:0,
                  data:  filterData[0],
                  original: { ...filterData[0] },
                  error: null,
                },() => {
                  this.updateURL(filterData[0]);
                });
              }else {
                this.setState({
                  filterData: [],
                  data: false,
                  error: "No filtered data found. Please try again with different filters.",
                });
              }
            })
            .catch((error) => {
              this.setState({
                data: false,
                error: error.message || "Unidentified Error",
              });
            });
        
    }
    
    
    updateURL(data) {
        const queryParams = new URLSearchParams(this.props.location.search);
        // const name = queryParams.get("name");
        // const newUrl = `/firm/${data.company_id}${name ? `?name=${name}` : ""}`;
        const newUrl = `/Lender/${data.contact_id}?${queryParams.toString()}`;
        browserHistory.push(newUrl);
      }

    fetch(id) {
        this.setState({
           // data: null, we have comment this line to avoid loading symbol has ali dont want to be screen get change when value is null we was showing loader 
            error: null,
            success: null,
        });

        if (id === undefined) {
            this.setState({
                data: { contact_type: ["Lender"] }
            });
            return;
        }

       
        const token = localStorage.getItem('authToken');

        // this.client.query({
        //     query: GET_LENDERS_BY_ID,
        //     variables: { arcimedes_row_id: id },
        //     fetchPolicy: "no-cache",
        //     context: {
        //       headers: {
        //         authorization: `Bearer ${token}`,
        //       },
        //     }
        // })
        fetchData(GET_LENDER_BY_CONTACTID, {contactid:parseInt(id) })
            .then((res) => {
    if (res && res.data && res.data.getContactByContactid) { 
        const lenderData = res.data.getContactByContactid.contact;
        const loggedInUserEmail = String(this.state.loggedInUserData.email);
        lenderData['hsc_hot_list'] = lenderData.hsc_id && lenderData.hsc_id.includes(loggedInUserEmail) ? '1' : '0';
        
        
        this.setState({
            data: lenderData,
            original: { ...lenderData },
            error: null,
        });
    } else {
        this.setState({
            data: false,
            error: res.message ? res.message : "Unidentified Error",
        });
    }
});
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({
            isExists:false,
            typeDuplicate:null
          });
        if (this.state.viewMode) this.setState({ viewMode: false });
 if (this.notesRef.current && this.notesRef.current.validateNotes) {
   const isValid = this.notesRef.current.validateNotes();
   if (!isValid) {
     console.log("Stop submit: notes invalid");
     return;
   }
 }
 if (!this.state.data.name) {
      this.setState({ errorTabs: [0], success: null });
      return;
    }
        if (
            this.state.isBusy ||
            //this.state.data.NAME === "" ||
            this.state.data.name === "" ||
            this.state.viewMode === true
        )
            return;

        this.setState({ viewMode: true }, () => this.saveData());
    }

    handleChangeInput(key, value) {
        this.setState((prevState) => {
          let newValue;
          if (key === "hsc_hot_list") {
            newValue = prevState.data[key] === "1" ? "0" : "1"; // Toggle
          } else {
            newValue = value;
          }
            return {
            data: {
                ...prevState.data,
                [key]: newValue,
            }
        };
    });
}

    handleChangeDropdown(query, queryType, x, key) {
        const userContactTypes = key === "contact_type" && query.contact_type.split(',').map(type => type.trim());

    if (key === "contact_type" && (userContactTypes.length > 1 || query.contact_type === "Lender") && this.state.typeDuplicate) {
      const match = this.state.typeDuplicate.match(/for\s(.+?)\stype/i); // extract "Agent, Investor, Lender"
      const messageContactTypes = match ? match[1].split(',').map(type => type.trim()) : [];

      const hasMatch = userContactTypes.some(type => messageContactTypes.includes(type));
      if (!hasMatch) {
        this.setState({
          isExists: false,
          typeDuplicate: null,
          isBusy: false,
        });
      }
    }
        this.setState({
            data: Object.assign(this.state.data, {
                [key]: query[key],
            }),
        });
    }
    setPropertiesData(data) {
        this.setState({ propertiesData: data })
    }

    saveData() {
        if (this.state.isBusy) return;
        let self = this;

        this.setState({
            isBusy: true,
            error: null,
            success: null,
        });

        delete this.state.data.__typename;
        delete this.state.data.arcimedes_modified
        delete this.state.data.arcimedes_modified_by

        const newData = { ...this.state.data };
        const loggedInUserEmail = this.state.loggedInUserData.email;
    
    if (newData["hsc_hot_list"] === "1") {
        let hotListAgents = [];

        if (newData && newData.hsc_id) {
            hotListAgents = newData.hsc_id
                .split(",")
                .map(id => id.trim())
                .filter((id, index, self) => id && self.indexOf(id) === index); // Remove duplicates
        }

        if (!hotListAgents.includes(String(loggedInUserEmail))) {
            hotListAgents.push(String(loggedInUserEmail));
        }

        newData.hsc_id = hotListAgents.join(",");
    } 
    else if (newData["hsc_hot_list"] === "0") {
        if (newData.hsc_id) {
            const loggedInUserEmailStr = String(loggedInUserEmail);
            let followUpList = newData.hsc_id ? newData.hsc_id.split(",") : [];
            let hotListAgents = followUpList.filter(email => email.trim() !== loggedInUserEmailStr);
            newData.hsc_id = hotListAgents.length > 0 ? hotListAgents.join(",") : "";
        }
    }
    
    delete newData.hsc_hot_list;
        
        const input = {...newData, 
            contact_type: Array.isArray(newData.contact_type) ? newData.contact_type
            : typeof newData.contact_type === "string"
            ? newData.contact_type.split(",")
            : ["Lender"],
            website: newData.website ? newData.website:'' ,
            hsc_id: newData.hsc_id ? String(newData.hsc_id) : null,
            notes: sanitizeNotesForInput(newData.notes)
            // cell_phone: this.state.data.contact_type.includes("Team") && this.state.data.cell_phone ? this.state.data.cell_phone : null,
            //contact_type: this.state.data.contact_type ?  this.state.data.contact_type.split(",") : ["Lender"]
        };
        //const token = localStorage.getItem('authToken');
    //    return this.client.mutate({
    //         mutation: CREATE_OR_UPDATE_CONTACTS_LENDERS,
    //         variables: { input: inputData },
    //         fetchPolicy: "no-cache",
    //         context: {
    //           headers: {
    //             authorization: `Bearer ${token}`,
    //           },
    //         },
    //       })
          return mutateData(CREATE_OR_UPDATE_CONTACTS_LENDERS,{input})
        .then(
            (res) => {
                //if (res && res.data && res.data.createOrUpdateLenders && res.data.createOrUpdateLenders.data) {
                if (res && res.data && res.data.createOrUpdateContact && res.data.createOrUpdateContact.contact) {

                  const lenderData = res.data.createOrUpdateContact.contact;
                  const hscIdList = (lenderData.hsc_id || "").split(",");
                  lenderData.hsc_hot_list = hscIdList.includes(loggedInUserEmail) ? '1' : '0';
                    this.setState(
                        {
                            isBusy: false,
                            success: "Saved",
                            data: res.data.createOrUpdateContact.contact,
                            original: self.state.data
                        },
                        () => {
                            if (!this.props.edit) {
                                browserHistory.push({
                                   // pathname: `/lender/${res.data.createOrUpdateLenders.data[0].ARCIMEDES_ROW_ID}`,
                                    pathname: `/lender/${res.data.createOrUpdateContact.contact.contact_id}`,
                                });
                            }
                        }
                    );
                    window.scrollTo(0, 0);
                } 
                else if(res && res.data && res.data.createOrUpdateContact && res.data.createOrUpdateContact.error && res.data.createOrUpdateContact.error.includes("already exists")){
                    this.setState({
                    isExists:true,
                    typeDuplicate: res.data.createOrUpdateContact.error,
                    viewMode:false
                  })
                  }else {
                    this.setState({
                        isBusy: null,
                        error: res && res.createOrUpdateContact.error ? res.createOrUpdateContact.error : "Unspecified error",
                    });
                }
            }
        );
    }

    render() {
        const data = this.state.data;
        const { edit, isSuper } = this.props;

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
                      <CRUDOLD
                        tabsData={[
                          {
                            name: "LENDER",
                            renderedComponent: (
                              <LenderInfo
                                isExists={this.state.isExists}
                                typeDuplicate={this.state.typeDuplicate}
                                data={data}
                                handleChangeInput={this.handleChangeInput}
                                handleChangeDropdown={this.handleChangeDropdown}
                                viewMode={this.state.viewMode}
                                //deleted={data && data.DELETED === "1"}
                                deleted={data && data.deleted === "1"}
                                handleParentDropdownChange={
                                  this.handleChangeDropdown
                                }
                              />
                            ),
                          },
                          {
                            name: "Properties",
                            renderedComponent: (
                              <LenderProperty
                                data={data}
                                propertiesData={this.state.propertiesData}
                                setPropertiesData={this.setPropertiesData}
                              />
                            ),
                          },
                          {
                            name: "Lender Company",
                            renderedComponent: (
                              <LenderCompanyInfo
                                data={data}
                                handleChangeInput={this.handleChangeInput}
                                handleChangeDropdown={this.handleChangeDropdown}
                                viewMode={this.state.viewMode}
                                deleted={data && data.deleted === "1"}
                              />
                            ),
                          },
                          {
                            name: "NOTES",
                            renderedComponent: (
                              <NotesReusable
                               data={data}
                                notes={data && data.notes ? data.notes : []}
                                contact_id={
                                  data && data.contact_id
                                    ? data.contact_id
                                    : null
                                }
                                viewMode={this.state.viewMode}
                                handleChangeInput={this.handleChangeInput}
                                ref={this.notesRef}
                                //deleted={data && data.DELETED === "1"}
                                deleted={data && data.deleted === "1"}
                                setState={this.setState.bind(this)}
                                onNotesChange={this.handleNotesChange}
                                state={this.state}
                              />
                            ),
                          },
                        ]}
                        backLink={`${arc.path.base}contacts/lenders`}
                        edit={edit}
                        state={this.state}
                        setState={this.setState.bind(this)}
                        handleSubmit={this.handleSubmit}
                        saveData={this.saveData}
                        type="lender"
                        backName="LENDERS"
                        //title={data && `${data.name} - ${data.city ? data.city : ''}, ${data.state ? data.state : ''}`}
                        title={
                          data &&
                          `${data.name} - ${data.city ? data.city : ""}, ${
                            data.state ? data.state : ""
                          }`
                        }
                        isSuper={isSuper}
                        filterData={this.state.filterData}
                        currentIndex={this.state.currentIndex}
                        updateURL={this.updateURL}
                        // backToUrl={"lenders"}
                        backToUrl={
                          this.state.fromListUrl
                            ? this.state.fromListUrl
                            : "/lenders"
                        }
                      />
                    );
                }}
            </ApolloConsumer>

        );
    }
}


// import React from "react";
// import { LENDERS } from "../../consts/tables";
// import LenderInfo from "./LenderInfo";
// import LenderProperty from "./LenderProperty";
// import NotesInfo from "./NotesInfo";
// import CRUD from "../CRUD/CRUD";
// import { browserHistory } from "react-router";
// import { getData, manageData } from "../../requests/CRUD";
// import { GET_LENDERS, GET_LENDERS_BY_ID } from "../Graphql/Queries/LendersQuery";
// import { CREATE_LENDERS } from "../Graphql/Mutations/LendersMutation";
// import { ApolloConsumer } from "@apollo/client";

// export default class CRUDLender extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             data: null,
//             original: null,
//             isBusy: null,
//             error: null,
//             success: null,
//             errorTabs: [],
//             currentTab: 0,
//             viewMode: this.props.edit || false,
//             propertiesData: []
//         };

//         this.client = null;

//         this.handleSubmit = this.handleSubmit.bind(this);
//         this.handleChangeInput = this.handleChangeInput.bind(this);
//         this.saveData = this.saveData.bind(this);
//         this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
//         this.setPropertiesData = this.setPropertiesData.bind(this);
//     }

//     componentWillReceiveProps(nextProps) {
//         if (this.props.params.id !== nextProps.params.id) {
//             this.fetch(nextProps.params.id);
//         }
//     }

//     componentDidMount() {
//         this.fetch(this.props.params.id);
//     }

//     fetch(id) {
//         this.setState({
//             data: null,
//             error: null,
//             success: null,
//         });

//         if (id === undefined) {
//             this.setState({
//                 data: {},
//             });
//             return;
//         }

//         this.client.query({
//             query: GET_LENDERS_BY_ID,
//             variables: { arcimedes_row_id: id },
//             context: {
//                 headers: {
//                     authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InByYXZpcHVkaUBzYWdlaXRpbmMuY29tIiwiaWQiOjMyOSwicm9sZSI6IlN1cGVyIFVzZXIiLCJpYXQiOjE3MjU2MjM0MDAsImV4cCI6MTcyODIxNTQwMH0.cmuEOr-82RKRMTymgB21ZlOJP09mtWOxW50hszQ8ADU', // Bearer token added here
//                 },
//             },
//         }).then((res) => {
//             if (res && res.data && res.data.getLender) {
//                 this.setState({
//                     data: res.data.getLender,
//                     original: { ...res.data.getLender },
//                     error: null,
//                 });
//             } else {
//                 this.setState({
//                     data: false,
//                     error: res.message ? res.message : "Unidentified Error",
//                 });
//             }
//         });
//     }

//     handleSubmit(client, e) {
//         e.preventDefault();

//         if (this.state.viewMode) this.setState({ viewMode: false });

//         if (
//             this.state.isBusy ||
//             this.state.data.name === "" ||
//             this.state.viewMode === true
//         )
//             return;

//         this.setState({ viewMode: true }, () => this.saveData(client));
//     }

//     handleChangeInput(key, value) {
//         this.setState(prevState => ({
//             data: {
//                 ...prevState.data,
//                 [key]: value
//             }
//         }));
//     }

//     handleChangeDropdown(query, queryType, x, key) {
//         this.setState(prevState => ({
//             data: {
//                 ...prevState.data,
//                 [key]: query[key]
//             }
//         }));
//     }
//     setPropertiesData(data) {
//         this.setState({ propertiesData: data })
//     }

//     async saveData(client) {
//         if (this.state.isBusy) return;
//         let self = this;

//         this.setState({
//             isBusy: true,
//             error: null,
//             success: null,
//         });

//         // return manageData({ tableCode: LENDERS, data: [this.state.data] }).then(
//         //     (res) => {
//         //         if (res && res.success) {
//         //             this.setState(
//         //                 {
//         //                     isBusy: false,
//         //                     success: "Saved",
//         //                     original:self.state.data                            
//         //                 },
//         //                 () => {
//         //                     if (!this.props.edit) {
//         //                         browserHistory.push({
//         //                             pathname: `/lender/${res.data[0].ARCIMEDES_ROW_ID}`,
//         //                         });
//         //                     }
//         //                 }
//         //             );
//         //             window.scrollTo(0, 0);
//         //         } else {
//         //             this.setState({
//         //                 isBusy: null,
//         //                 error: res && res.message ? res.message : "Unspecified error",
//         //             });
//         //         }
//         //     }
//         // );
//         var pageParams = {
//             page: 1,
//             pageSize: 50
//         }
//         try {
//             const res = await client.mutate({
//                 mutation: CREATE_LENDERS,
//                 variables: {
//                     arcimedes_row_id: this.props.params.id,
//                     name: this.state.data.name,
//                     city: this.state.data.city,
//                     state: this.state.data.state,
//                     contact_name: this.state.data.contact_name,
//                     contact_phone: this.state.data.contact_phone,
//                     contact_email: this.state.data.contact_email,
//                     notes: this.state.data.notes
//                     // Add other fields as needed
//                 },
//                 context: {
//                     headers: {
//                         authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InByYXZpcHVkaUBzYWdlaXRpbmMuY29tIiwiaWQiOjMyOSwicm9sZSI6IlN1cGVyIFVzZXIiLCJpYXQiOjE3MjU2MjM0MDAsImV4cCI6MTcyODIxNTQwMH0.cmuEOr-82RKRMTymgB21ZlOJP09mtWOxW50hszQ8ADU', // Bearer token added here
//                     },
//                 },
//                 refetchQueries: [{ query: GET_LENDERS, variables: { pageOptions: pageParams },
//                     context: {
//                         headers: {
//                             authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InByYXZpcHVkaUBzYWdlaXRpbmMuY29tIiwiaWQiOjMyOSwicm9sZSI6IlN1cGVyIFVzZXIiLCJpYXQiOjE3MjU2MjM0MDAsImV4cCI6MTcyODIxNTQwMH0.cmuEOr-82RKRMTymgB21ZlOJP09mtWOxW50hszQ8ADU', // Bearer token added here
//                         },
//                     } }],
//             });

//             if (res && res.data) {
//                 this.setState({
//                     isBusy: false,
//                     success: "Saved",
//                 }, () => {
//                     if (!this.props.edit) {
//                         browserHistory.push({
//                             pathname: `/lender/${res.data.createOrUpdateLender.lender.arcimedes_row_id}`,
//                         });
//                     }
//                 });

//                 window.scrollTo(0, 0);
//             }
//         } catch (error) {
//             console.error("Error in saveData:", error);
//             this.setState({
//                 isBusy: false,
//                 error: error.message || "Unspecified error",
//             });
//         }
//     }

//     render() {
//         const data = this.state.data;
//         const { edit, isSuper } = this.props;

//         return (
//             <ApolloConsumer>
//                 {client => {
//                     if (!this.client) this.client = client;
//                     return (
//                         <CRUD
//                             tabsData={[
//                                 {
//                                     name: "LENDER",
//                                     renderedComponent: (
//                                         <LenderInfo
//                                             data={data}
//                                             handleChangeInput={this.handleChangeInput}
//                                             handleChangeDropdown={this.handleChangeDropdown}
//                                             viewMode={this.state.viewMode}
//                                             deleted={data && data.deleted === "1"}
//                                         />
//                                     ),
//                                 },
//                                 {
//                                     name: "NOTES",
//                                     renderedComponent: (
//                                         <NotesInfo
//                                             data={data}
//                                             viewMode={this.state.viewMode}
//                                             handleChangeInput={this.handleChangeInput}
//                                             deleted={data && data.deleted === "1"} />
//                                     ),
//                                 },
//                                 {
//                                     name: "Properties",
//                                     renderedComponent: (
//                                         <LenderProperty data={data} propertiesData={this.state.propertiesData} setPropertiesData={this.setPropertiesData} />
//                                     ),
//                                 },
//                             ]}
//                             backLink={`${arc.path.base}lenders`}
//                             edit={edit}
//                             state={this.state}
//                             setState={this.setState.bind(this)}
//                             handleSubmit={(e) => this.handleSubmit(client, e)}
//                             saveData={this.saveData}
//                             type="lender"
//                             backName="LENDERS"
//                             title={data && `${data.name} - ${data.city ? data.city : ''}, ${data.state ? data.state : ''}`}
//                             isSuper={isSuper}
//                         />
//                     )
//                 }}
//             </ApolloConsumer>
//         );
//     }
// }
